module.exports = __webpack_public_path__ + "fonts/Kent4FPrintedShadowed.949dd36.woff";